/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Contract_Purchase_Number_PlaceholderInputs */

const en_cargo_contract_purchase_number_placeholder = /** @type {(inputs: Cargo_Contract_Purchase_Number_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6643A`)
};

const es_cargo_contract_purchase_number_placeholder = /** @type {(inputs: Cargo_Contract_Purchase_Number_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6643A`)
};

/**
* | output |
* | --- |
* | "6643A" |
*
* @param {Cargo_Contract_Purchase_Number_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_contract_purchase_number_placeholder = /** @type {((inputs?: Cargo_Contract_Purchase_Number_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Contract_Purchase_Number_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_contract_purchase_number_placeholder(inputs)
	return es_cargo_contract_purchase_number_placeholder(inputs)
});